import { AppProvider } from 'providers/AppProvider';
import { buildAppState } from 'store/state';
import { Endpoints } from 'consts';

export type AppState = ReturnType<typeof buildAppState>;

export type AppCTX = ReturnType<typeof AppProvider>;

export enum ENVIRONMENT {
	DEV = 'dev',
	DEVELOPMENT = 'development',
	TEST = 'test',
	PRODUCTION = 'production'
}

export type AppConfig = Readonly<{
	API_CONTENT_URL: string;
	API_DIGITAL_SIGNATURE_URL: string;
	API_URL: string;
	API: Endpoints;
	APP_ENV: ENVIRONMENT;
	CURITY_AUTHORIZATION_URL: string;
	CURITY_CLIENT_ID: string;
	CURITY_CLIENT_SECRET: string;
	CURITY_METADATA_URL: string;
	CURITY_OAUTH_TOKEN_URL: string;
	ENABLE_RESET_VIEW: boolean;
	IS_ALLOWED_TO_CHANGE_LANGUAGE: boolean;
	IS_EMPLOYEE_WEB: boolean;
}>;
